export const getAggregateVotes = (uncertainties, votes) => {
  const aggregated = {};
  
  // Group votes by uncertainty_id
  votes.forEach(vote => {
    if (!aggregated[vote.uncertainty_id]) {
      aggregated[vote.uncertainty_id] = {
        impacts: [],
        uncertainties: []
      };
    }
    aggregated[vote.uncertainty_id].impacts.push(vote.impact);
    aggregated[vote.uncertainty_id].uncertainties.push(vote.uncertainty_level);
  });

  return uncertainties.map(unc => {
    const voteData = aggregated[unc.id];
    if (!voteData || voteData.impacts.length === 0) {
      return { name: unc.title, impact: 0, uncertainty: 0, category: unc.category };
    }
    const avgImpact = voteData.impacts.reduce((a, b) => a + b, 0) / voteData.impacts.length;
    const avgUncertainty = voteData.uncertainties.reduce((a, b) => a + b, 0) / voteData.uncertainties.length;
    return {
      name: unc.title,
      impact: Math.round(avgImpact * 10) / 10,
      uncertainty: Math.round(avgUncertainty * 10) / 10,
      category: unc.category
    };
  });
};

export const getRadarData = (uncertainties, votes) => {
  const categories = ['Technology', 'Policy', 'Economic', 'Social', 'Environmental'];
  const aggregateVotes = getAggregateVotes(uncertainties, votes);
  
  return categories.map(cat => {
    const categoryUncertainties = uncertainties.filter(u => u.category === cat);
    const categoryVotes = aggregateVotes.filter(v => v.category === cat);
    const avgImpact = categoryVotes.length > 0
      ? categoryVotes.reduce((sum, v) => sum + v.impact, 0) / categoryVotes.length
      : 0;
    return {
      category: cat,
      value: Math.round(avgImpact * 10) / 10,
      count: categoryUncertainties.length
    };
  });
};